import FormField from "models/FormField";

/**
 * This class represents a Form fetched from the API including all the needed business functions/methods related.
 */
class Form {
  /** ---------------- Mappers functions ---------------- */
  static fromAPI = (data) => ({
    eventId: data?.event,
    fields: data?.fields?.map((field) => {
      if (Object.hasOwn(field, "is_required")) {
        return FormField.fromAPI(field);
      }
      return FormField.fromAPIOld(field);
    }),
    initialValues: data?.initial_values,
    name: data?.name,
    id: data?.id,
  });

  /** ---------------- Business functions ---------------- */
}

export default Form;
